import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BobineLoader from "../components/BobineLoader";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'https://bobine.live');
const API = `${BACKEND_URL}/api`;

/**
 * DemoPage — point d'entrée pour pitch concours.
 * Réinitialise le compte démo à chaque visite et redirige vers le Dashboard
 * en tant qu'utilisateur factice "Léa Démonstration".
 *
 * URL : /demo
 *
 * Charte stricte : Or #D4AF37, ivoire #F7E6BD, noir #000000.
 */
const DemoPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [step, setStep] = useState("Préparation de votre démonstration…");
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return; // StrictMode guard
    calledRef.current = true;
    (async () => {
      try {
        setStep("Préparation de votre démonstration…");
        // Sauvegarder la session réelle si elle existe (pour pouvoir la restaurer en quittant /demo)
        const previousToken = localStorage.getItem("bobine_token");
        const previousUser = localStorage.getItem("bobine_user");
        const previousIsDemo = localStorage.getItem("bobine_is_demo");
        if (previousToken && previousIsDemo !== "1") {
          localStorage.setItem("bobine_prev_token", previousToken);
          if (previousUser) localStorage.setItem("bobine_prev_user", previousUser);
        }
        const r = await axios.post(`${API}/demo/init`, {}, { timeout: 90000 });
        if (r.data?.token && r.data?.user) {
          localStorage.setItem("bobine_token", r.data.token);
          localStorage.setItem("bobine_user", JSON.stringify(r.data.user));
          localStorage.setItem("bobine_is_demo", "1");
          localStorage.setItem("bobine-onboarding-seen", "1");
          window.dispatchEvent(new Event("bobine-user-updated"));
          setStep("Le coffre s'ouvre…");
          setTimeout(() => navigate("/dashboard", { replace: true }), 900);
        } else {
          setError("Réponse inattendue du serveur.");
        }
      } catch (e) {
        setError(e?.response?.data?.detail || "Impossible d'initialiser la démonstration.");
      }
    })();
  }, [navigate]);

  return (
    <div data-testid="demo-page" style={{
      minHeight: "100vh",
      background: "#000000",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
      textAlign: "center",
    }}>
      <div style={{ marginBottom: 32 }}>
        <BobineLoader size={72} />
      </div>

      <h1 style={{
        fontFamily: "'Georgia', serif",
        fontSize: 22,
        color: "#D4AF37",
        fontWeight: 400,
        letterSpacing: 1.5,
        margin: "0 0 12px",
      }}>
        Mode Démonstration
      </h1>

      {!error ? (
        <p data-testid="demo-step" style={{
          fontFamily: "'Georgia', serif",
          fontSize: 14,
          color: "#F7E6BD",
          fontStyle: "italic",
          margin: 0,
          opacity: 0.85,
          letterSpacing: 0.3,
        }}>
          {step}
        </p>
      ) : (
        <div style={{ maxWidth: 420 }}>
          <p data-testid="demo-error" style={{
            fontFamily: "'Georgia', serif",
            fontSize: 14,
            color: "#F7E6BD",
            fontStyle: "italic",
            margin: "0 0 20px",
          }}>
            {error}
          </p>
          <button
            data-testid="demo-retry"
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 28px",
              borderRadius: 24,
              border: "1px solid #D4AF37",
              background: "linear-gradient(135deg, #D6BB6A 0%, #C9A632 30%, #A8830C 65%, #6B4F0A 100%)",
              color: "#000",
              fontFamily: "'Georgia', serif",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              letterSpacing: 0.5,
            }}
          >
            Réessayer
          </button>
        </div>
      )}

      <p style={{
        fontFamily: "'Georgia', serif",
        fontSize: 11,
        color: "rgba(212,175,55,0.5)",
        fontStyle: "italic",
        margin: "40px 0 0",
        letterSpacing: 0.3,
      }}>
        Données factices · Aucun envoi d'email · Aucune transaction
      </p>
    </div>
  );
};

export default DemoPage;
